import { render, staticRenderFns } from "./Traceability.vue?vue&type=template&id=216287e6&scoped=true"
import script from "./Traceability.vue?vue&type=script&lang=js"
export * from "./Traceability.vue?vue&type=script&lang=js"
import style0 from "./Traceability.vue?vue&type=style&index=0&id=216287e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216287e6",
  null
  
)

export default component.exports